import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { getSmartCartApi } from '@app/pages/checkout-app/utils/api.utils';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class SmartCartApi {
  private readonly API_URL = getSmartCartApi();

  constructor(
    private http: HttpClient,
    private apiService: ApiService,
  ) {}

  get(path: string, options: any = {}): Observable<any> {
    const headers = { ...options.headers, ...this.getHeaders() };
    return this.http.get(this.API_URL + path, { ...options, headers });
  }

  post(path: string, body: any, options: any = {}): Observable<any> {
    const headers = { ...options.headers, ...this.getHeaders() };
    return this.http.post(this.API_URL + path, body, { ...options, headers });
  }

  patch(path: string, body: any, options: any = {}): Observable<any> {
    const headers = { ...options.headers, ...this.getHeaders() };
    return this.http.patch(this.API_URL + path, body, { ...options, headers });
  }

  delete(path: string, options: any = {}): Observable<any> {
    const headers = { ...options.headers, ...this.getHeaders() };
    return this.http.delete(this.API_URL + path, { ...options, headers });
  }

  private getHeaders() {
    return {
      Authorization: `Bearer ${this.apiService.jwtToken}`,
    };
  }
}
